// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/common/DonutSliceChart.scss
// module id = 1306
// module chunks = 0